import styles from "./Topbanner.module.scss";

function WithoutImageBanner() {
    return (
        <>
            <section
                className={styles.without_image_banner}
            >
            </section>
        </>
    )
}
export default WithoutImageBanner;